import {
	SHOW_LOADING,
	HIDE_LOADING,
	CHANGE_LANGUAGE,
	CHANGE_MODE,
} from "../actions/types";
import { modeTypes } from "../constants/mode";
import { ActionModel } from "../model/Utilities";

interface AppState {
	loading: boolean;
	language: string;
	loadingText?: string;
	mode: string;
}

const localLanguage = localStorage.getItem("Language");

const initialState: AppState = {
	loading: false,
	language: localLanguage || "en",
	mode: localStorage.getItem("currentMode") || modeTypes.TRANSFER,
};

export default function appReducer(state = initialState, action: ActionModel) {
	const { type, payload } = action;

	switch (type) {
		case SHOW_LOADING:
			return {
				...state,
				loading: true,
				loadingText: payload.text,
			};
		case HIDE_LOADING:
			return {
				...state,
				loading: false,
				loadingText: "",
			};
		case CHANGE_LANGUAGE:
			return {
				...state,
				language: payload,
			};
		case CHANGE_MODE:
			return {
				...state,
				mode: payload,
			};
		default:
			return state;
	}
}
